import { styled } from 'styled-components';
import {
  SH1Menu,
  SH2Menu,
  SH3Menu,
  SPMenu,
} from '~/pages/components/styles/styles';

type IProps = {
  hidden?: boolean;
};

/*

<SPMenu fontWeight="700"></SPMenu>

<SPMenu></SPMenu>
*/
export function Mentions({ hidden }: IProps) {
  return (
    <Container hidden={hidden}>
      <Wrapper>
        <SH1Menu fontWeight="700">Mentions légales</SH1Menu>
        <br />
        <SPMenu fontWeight="700">
          Bienvenue sur l’application BYES ECO GESTES Université de Saclay.
        </SPMenu>
        <SPMenu fontWeight="700">
          Cette page décrit les conditions juridiques applicables à tout
          internaute visitant la présente Application.
        </SPMenu>
        <SPMenu fontWeight="700">
          En consultant cette Application, vous vous engagez sans réserve à
          respecter les présentes conditions.{' '}
        </SPMenu>
        <SPMenu fontWeight="700">
          Ces conditions pouvant être modifiées à tout moment sans préavis, nous
          vous invitons à les consulter régulièrement.
        </SPMenu>
        <br />
        <SH2Menu fontWeight="700">1 – Informations d’ordre général</SH2Menu>
        <SPMenu>
          La présente application accessible via le QR code suivant est la
          propriété de la société BYES.
        </SPMenu>
        <SPMenu>
          L’application est éditée par la société BYES : société par actions
          simplifiée au capital social de 61 936 288 Euros, immatriculée au
          R.C.S. de Versailles sous le numéro 775664873 ; N° de TVA
          intracommunautaire : FR36775664873; siège social : BOUYGUES ENERGIES &
          SERVICES, IMMEUBLE ATLANTIS 1 AVENUE EUGENE FREYSSINET 78280
          GUYANCOURT (FRANCE) ; ci-après dénommée « BYES » ou « nous ».
        </SPMenu>
        <SPMenu>Adresse électronique de contact : seriousgame@byes.com</SPMenu>
        <SPMenu>
          L’application est co-éditée par la société My-Serious-Game : société
          par actions simplifiée au capital social de 4 125 Euros, immatriculée
          au R.C.S. de Tours Métropole sous le numéro 804 673 754 ; N° de TVA
          intracommunautaire : FR 25 804 673 754 ; siège social : 1 rue Gambetta
          – 37000 Tours (FRANCE) ; ci-après dénommée « My-Serious-Game ».
        </SPMenu>
        <SPMenu>
          Adresse électronique de contact : contact@my-serious-game.com
        </SPMenu>
        <SPMenu>Tél : + 33 (0)245 340 440</SPMenu>
        <br />
        <SH2Menu fontWeight="700">2 – Conception de la Plateforme</SH2Menu>
        <SPMenu>
          L’application a été conçue et développée par la société
          My-Serious-Game.
        </SPMenu>
        <br />
        <SH2Menu fontWeight="700">3 – Hébergement de la Plateforme</SH2Menu>
        <SPMenu>
          La Plateforme est hébergée par la société My-Serious-Game : société
          par actions simplifiée au capital social de 4 125 Euros, immatriculée
          au R.C.S. de Tours Métropole sous le numéro 804 673 754 ; N° de TVA
          intracommunautaire : FR 25 804 673 754 ; siège social : 1 rue Gambetta
          – 37000 Tours (FRANCE).
        </SPMenu>
        <SPMenu>
          Adresse électronique de contact : contact@my-serious-game.com
        </SPMenu>
        <SPMenu>Tél : + 33 (0)245 340 440</SPMenu>
        <br />
        <SH2Menu fontWeight="700">4 – Propriété Intellectuelle</SH2Menu>
        <SH3Menu fontWeight="700">4.1 – Droits d’auteur</SH3Menu>
        <SPMenu>
          Toutes les informations apparaissant sur le site (documents présentés
          sur le site ainsi que tous les éléments créés pour le site) sont la
          propriété de BYES ou de ses filiales et entités affiliées. Les copies
          des documents présentés sur l’application ne peuvent être réalisées
          qu’à titre d’information et exclusivement pour un usage strictement
          privé.
        </SPMenu>
        <SPMenu>
          Aucune licence, ni aucun autre droit que celui de consulter le site,
          n’est conféré à quiconque au regard des droits de propriété
          intellectuelle. La reproduction des documents du site est autorisée à
          des fins exclusives d’information pour un usage personnel et privé :
          toute reproduction et toute utilisation de copie réalisée à d’autres
          fins est expressément interdite.
        </SPMenu>
        <SPMenu>
          Il en est de même pour les bases de données sous-jacentes au
          fonctionnement du présent Site, dont l’extraction ou la réutilisation
          du contenu est sanctionnée.
        </SPMenu>
        <br />
        <SH3Menu fontWeight="700">4.2 – Signes distinctifs</SH3Menu>
        <SPMenu>
          Sauf mention contraire, les dénominations sociales, les logos, les
          produits et marques cités sur la présente Application sont la
          propriété de BYES. Ils ne peuvent être utilisés sans l’autorisation
          écrite préalable de BYES.
        </SPMenu>
        <br />
        <SH2Menu fontWeight="700"> 5 – Témoins de connexion (Cookies)</SH2Menu>
        <SPMenu>
          Lors de vos visites, vous êtes informés qu’un témoin de connexion peut
          s’installer automatiquement sur votre navigateur internet. Il s’agit
          d’un bloc de données non utilisé à des fins d’identification mais
          visant à enregistrer des informations relatives à votre navigation sur
          la présente application. Il permet des analyses de fréquentation et de
          mesures d’audience afin d’améliorer la qualité de l’application.
        </SPMenu>

        <br />
        <SH2Menu fontWeight="700">
          6 – Loi applicable et juridiction compétente
        </SH2Menu>
        <SPMenu>
          Les présentes conditions sont soumises aux dispositions de la loi
          française. En cas de litige, le requérant pourra saisir le tribunal
          compétent dans le ressort duquel la partie défenderesse a son domicile
          ou sa résidence.
        </SPMenu>
        <br />
      </Wrapper>
      <SDivBlur></SDivBlur>
    </Container>
  );
}

const Wrapper = styled.div`
  height: 100%;
  overflow-y: auto;
  padding: 30px;
  width: 100%;

  @media screen and (max-width: 415px) {
    padding: 0 30px 30px 30px;
  }
  @media screen and (max-height: 600px) {
    padding: 0 30px 30px 30px;
  }
`;

const Container = styled.div<{ hidden?: boolean }>`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: ${({ hidden }) => (hidden ? '0' : '100%')};
  opacity: ${({ hidden }) => (hidden ? '0' : '1')};
  position: relative;
  overflow-y: auto;
  transition: all 0.3s 1s linear;
  width: 100%;
`;

const SDivBlur = styled.div`
  bottom: 0;
  background-image: linear-gradient(to bottom, rgba(0, 159, 195, 0), #009fc3);
  left: 0;
  height: 52px;
  position: absolute;
  width: 100%;
`;
